
import filters from "@/mixins/filters";
import {mapActions} from "vuex";

export default {
	mixins: [filters],
	props: {
		offer: Object
	},
	methods: {
		...mapActions({
			openModal: 'modal/modal-main/openModal'
		}),
		moreInfoComplectation(carInfo) {
			let payload = {
				modal_data: carInfo,
				modal_component: 'modal-complect',
				modal_title: 'Комплектация',
				modal_sub_title: carInfo.name
			}
			this.openModal(payload)
		},
	}
}
